<template>
  <div class="footer clearfloat">
    <div class="fl footer_inner01">
      <img src="../assets/img/footer_logo.gif" alt="" />
    </div>
    <div class="fl footer_inner02">
      <p>版权所有：（C）甘肃公航旅置业有限公司 2019</p>
      <p>联系地址：甘肃省兰州市城关区中山桥南面</p>
      <p>联系电话：0931—8465824</p>
      <p>备案序号：<a href="http://beian.miit.gov.cn">甘ICP备19002096</a></p>
    </div>
    <div class="fr footer_inner03">
      <p>
        <a v-show="footerShow01" href="/">返回首页</a
        ><a v-show="footerShow02" href="">设为首页</a> |
        <a style="cursor: pointer" @click="dialogFormVisible = true"
          >在线留言</a
        >
      </p>
    </div>

    <!-- <el-dialog title="在线留言" :visible.sync="dialogFormVisible" width="30%">
      <el-form :model="form">
        <el-form-item label="姓名" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" :label-width="formLabelWidth">
          <el-input v-model="form.phone" autocomplete="off" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="留言内容" :label-width="formLabelWidth">
          <el-input type="textarea" :rows="5" v-model="form.content" autocomplete="off" placeholder="请输入留言内容"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
      </div>
    </el-dialog> -->

    <el-dialog title="在线留言" :visible.sync="dialogFormVisible" width="40%">
      <!-- <ul class="infinite-list" v-infinite-scroll="load" style="overflow: auto"> -->
      <ul class="infinite-list" style="overflow: auto">
        <li v-for="(item,index) in messageList" :key="index" class="infinite-list-item">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>{{ index + 1 }} 楼</span>
              <el-button style="float: right; padding: 3px 0" type="text"
                >游客 {{ item.create_time }} 留言</el-button
              >
            </div>
            <div class="text item">
              {{ item.message }}
            </div>
          </el-card>
        </li>
      </ul>
      <el-divider content-position="left">留言</el-divider>
      <el-form :model="form">
        <el-form-item>
          <el-input
            type="textarea"
            :rows="5"
            v-model="form.content"
            autocomplete="off"
            placeholder="请输入留言内容"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sendMessageList">确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      footerShow01: false,
      footerShow02: true,
      dialogFormVisible: false,
      form: {
        name: "",
        phone: "",
        content: ""
      },
      formLabelWidth: "120",
      count: 0,
      messageList: []
    };
  },
  mounted() {
    var _this = this;
    if (_this.$route.name == "jyxc" || _this.$route.name == "Jyxc") {
      _this.footerShow01 = true;
      _this.footerShow02 = false;
    }
    _this.getMessageList();
  },
  methods: {
    load() {
      this.count += 2;
    },
    async getMessageList(){
      var _this = this;
      var { data } = await _this.$http.post(_this.apiUrl + '/forum/getForum', {company_id: 7});
      console.log(data)
      _this.messageList=data.data
    },
    async sendMessageList(){
      var _this = this;
      if(_this.form.content==''){
        _this.$message({
          message: "请填写留言内容",
          type: "error"
        });
        return;
      }
      var { data } = await _this.$http.post(_this.apiUrl + '/forum/addForum', {company_id: 7, message: _this.form.content});
      if (data.code != 200) {
        _this.$message({
          message: data.msg,
          type: "error"
        });
      } else {
        _this.$message({
          message: data.msg,
          type: "success"
        });
        _this.form.content = '';
        _this.getMessageList();
      }
    }
  }
};
</script>

<style scoped>
.footer {
  padding: 10px 10px;
  margin-top: 10px;
  border-top: 4px solid #096cc4;
}

.footer p {
  line-height: 24px;
}

.footer a {
  color: #096cc4;
}

.footer a:hover {
  text-decoration: underline;
}

.footer_inner02 {
  margin-left: 12px;
}

.footer_inner03 a {
  margin: 0 6px;
}

.infinite-list {
  height: 600px;
  margin-bottom: 20px;
}

.infinite-list-item{
  padding-top: 20px;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 96%;
  margin: 0 auto;
  /* margin-bottom: 20px; */
}
</style>
